import script from "./ExcerptBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExcerptBlock.vue?vue&type=script&setup=true&lang=ts"

import "./ExcerptBlock.vue?vue&type=style&index=0&id=36f1719a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f1719a"]])

export default __exports__